import React, { ReactElement, useEffect, useState } from 'react';
import {
  useParams
} from 'react-router-dom';
import { Grid } from '@mui/material';
import {
  MandateContextProvider,
  SetUpdateHookContextProvider,
  PathHook
} from '../hooks/datatabs';
import {
  Nullable,
  Mandate
} from '../types/types';
import MandateHeader from '../containers/mandates/pageheader';
import { mandatesTabs } from '../utils/tabs';
import { MandateService } from '../services/mandate';
import DisplayTabs from '../components/layout/tabs/tabs';
import ServiceError from '../services/errors';
import ErrorPageManager from '../components/Error/errorpagemanager';
import TabsRouter from './tabsrouter';

function MandateRouter(): ReactElement {
  const { id } = useParams<{ id: string }>();
  const [update, setUpdate] = useState(true);
  const [data, setData] = useState<Nullable<Mandate>>(null);
  const mandateService = new MandateService();
  const [error, setError] = useState<Nullable<ServiceError>>(null);

  useEffect(() => {
    if (update && id) {
      data && setData(null);

      mandateService.getEntity(id)
        .then((apiResp) => {
          setData(apiResp.data);
          setUpdate(false);
        })
        .catch((err) => {
          setError(ServiceError.ensureServiceError(err));
          setUpdate(false);
        });
    }
  }, [update, id]);

  PathHook(`${data?.name}`);

  return (
    <SetUpdateHookContextProvider value={setUpdate}>
      <Grid container spacing={2}>
        {error ? <ErrorPageManager error={error} /> :
          <MandateContextProvider value={data}>
            <Grid item xs={12}>
              <MandateHeader entity={data} />
            </Grid>
            <Grid item xs={12}>
              <DisplayTabs tabs={mandatesTabs} />
            </Grid>
            <Grid item xs={12}>
              <TabsRouter tabs={mandatesTabs} />
            </Grid>
          </MandateContextProvider>
        }
      </Grid>
    </SetUpdateHookContextProvider>
  );
}

export default MandateRouter;
